import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/paverWalkway/blog-paver-walkway-001.jpg";
import img002 from "../../images/paverWalkway/blog-paver-walkway-002.jpg";
import img003 from "../../images/paverWalkway/blog-paver-walkway-003.jpg";
import img004 from "../../images/paverWalkway/blog-paver-walkway-004.jpg";
import img005 from "../../images/paverWalkway/blog-paver-walkway-005.jpg";
import img006 from "../../images/paverWalkway/blog-paver-walkway-006.jpg";
import img007 from "../../images/paverWalkway/blog-paver-walkway-007.jpg";
import img008 from "../../images/paverWalkway/blog-paver-walkway-008.jpg";
import img009 from "../../images/paverWalkway/blog-paver-walkway-009.jpg";
import img010 from "../../images/paverWalkway/blog-paver-walkway-010.jpg";
import img011 from "../../images/paverWalkway/blog-paver-walkway-011.jpg";
import { ViewPavers } from "../../../../CTA/CTA";

// SEO
// import SEO from "../../../../SEO/index.js";

export const PaverWalkwayData = {
  title:
    "14 Paver Walkway Ideas for Star Quality Curb Appeal in Southern California",
  image: img001,
  destination: "/blog/14-paver-walkway-ideas",
  date: "December 1, 2016",
  categories: ["blog", "driveways", "paving-stones"],
};

const PaverWalkway = () => {
  const blog = [PaverWalkwayData];

  return (
    <>
      {/* <SEO
        title="The Best Privacy Hedges for Southern California: 8 Plants to Know"
        description="Discover the seven best privacy hedges for Southern California homes and factors to take into consideration when planting hedges."
        profileURL={
          "https://www.pacificoutdoorliving.com/blog/best-privacy-hedges-southern-california-8-plants-know/"
        }
      /> */}
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              As the main entryway leading to your home, a front paver walkway
              is literally the first impression that visitors will have upon
              pulling up to your house. A beautiful path to your home boosts
              curb appeal and makes guests feel welcome.
            </p>

            <p>
              Before delving into specific materials and styles, make sure that
              you put some thought into the design and layout. The physical
              layout of the walkway should be the very first consideration, as
              this will determine many of the future ideas and components. It’s
              important to look at the big picture and work with a professional
              who can help you visualize and determine the ideal design.
            </p>

            <p>
              Once you start the process, there are many directions you can go.
              Here are 14 of our favorite paver walkway suggestions that will
              add stunning aesthetic to any home.
            </p>

            <h4 className="text-blue">1. Go Wide with It</h4>
            <p>
              The more frequently your front walkway is used, the wider the
              design should be. If it’s connecting to a driveway, which many
              designs are in Southern California, you most likely want it wide
              enough that two people could walk side by side comfortably.
            </p>
            <img src={img002} alt="Feature" />
            <p>
              The minimum width for a front walkway should be 42”, but a wider
              walkway up to 60” could really enhance the appearance of a home.
              Your landscape designer can help you figure out what width is best
              for your front yard.
            </p>
            <h4 className="text-blue">2. A Curve in the Road</h4>
            <p>
              There is no rulebook that says your front walkway has to be a
              straight line. A curve in the walkway adds some mystery and
              allure. It also adds a big boost to curb appeal.
            </p>
            <img src={img003} alt="Feature" />

            <h4 className="text-blue">3. The Oh So Fancy</h4>
            <p>
              If you have a contemporary home, chances are you want an elegant
              promenade leading up to your home. A front paver walkway does set
              the tone for what guests can expect, so think about a design that
              works best with existing context and your style and taste. A more
              modern walkway typically has clean lines and a smooth look.
            </p>

            <h4 className="text-blue">4. A Tad More Traditional</h4>
            <p>
              If it’s the traditional look you prefer, you might consider using
              something like an antique cobble paving stone or maybe even brick.
              Every paver manufacturer out there makes a product to complement
              any theme or look you are trying to achieve.
            </p>

            <img src={img004} alt="Feature" />

            <h4 className="text-blue">
              5. Choose Unique Paver Walkway Patterns
            </h4>
            <p>
              You can get really creative with your front walkway by adding a
              design or pattern. Whether it’s alternating colors or going so far
              as incorporating your family initials or house number, adding a
              unique paver walkway pattern makes your project truly one of a
              kind.
            </p>

            <img src={img005} alt="Feature" />

            <h4 className="text-blue">6. Between the Lines</h4>
            <p>
              One easy front paver walkway idea that still packs a lot of appeal
              is incorporating flanking bands that line the walkway on either
              side. These bands should be done in a solid color shade that
              accents the colors of your home. A popular choice is pavers that
              are dark gray or black.
            </p>

            <p>
              Then in between these lines, you can have some fun with varying
              colors or go with all one color and play with multiple paver sizes
              incorporated in your paver walkway pattern. Either way, those
              flanking bands give the path some nice definition and contrast.
            </p>

            <h4 className="text-blue">
              7. Create a Circle Within Your Walkway
            </h4>
            <p>
              One way to make your front paver walkway really stand out is to
              add a circle of pavers as it leads up to the porch. Circle kits
              are made of pavers that are tapered at one end in order to create
              a tight fit while rotating around each subsequent layer.
            </p>
            <img src={img006} alt="Feature" />
            <p>
              Whether this is done midway or closer to the porch, it adds some
              impressive grandeur, even in the simplest of projects.
            </p>

            <h4 className="text-blue">8. Get Geometric</h4>
            <img src={img007} alt="Feature" />
            <p>
              If a more modern or abstract look is your taste, consider a
              geometric design of interlocking rectangles or shapes. Instead of
              going straight or curved, a design like this brings bold angles
              together for a truly unique look.
            </p>

            <h4 className="text-blue">9. A Built - In Stop</h4>
            <p>
              If you have a long front walkway or a front yard where you spend a
              lot of time relaxing, you may want to consider building in a stop
              along the way with a sitting area.
            </p>
            <img src={img008} alt="Feature" />
            <p>
              Add a bench, some chairs, or any outdoor furniture so that your
              guests can stop and enjoy a particular eye - catching statue,
              water feature, or landscape design along your front path.
            </p>

            <h4 className="text-blue">10. Crossing Paths</h4>
            <p>
              Who ever said you needed to have just one walkway leading to your
              home? For a truly unique look, consider two pathways that perhaps
              veer off or come together as a circle around a beautiful looking
              tree or statue.
            </p>

            <h4 className="text-blue">11. Look Overhead</h4>
            <p>
              Another fun way to add interest to your front paver walkway is to
              add a vertical element such as a trellis or a pergola that guests
              can pass under. Adding an archway adds visual interest but also
              provides some shade which pairs nicely with the built in stop, as
              previously suggested.
            </p>
            <img src={img009} alt="Feature" />

            <h4 className="text-blue">
              12. Light Up your Path with Landscape Lighting
            </h4>
            <p>
              Nothing adds ambiance and curb appeal quite like pathway lighting.
              It’s incredibly welcoming to guests when they see the walkway lit
              up. A well - lit walkway is also extremely functional, making it
              less likely that you or your guests will trip and fall when
              entering the home at night. This I especially important if you
              have elements such as steps or an unexpected curve in your paver
              walkway.
            </p>
            <p>
              A well - lit front yard is not only easy to take your curb appeal
              to the next level, but it also provides a front yard that deters
              intruders. Talk to your landscape designer to see what options of
              lighting fixtures match your style and needs.
            </p>

            <h4 className="text-blue">13. A Pop of Color and Texture</h4>
            <p>
              When it comes to paver walkway landscaping, color and texture is
              so important. Small shrubs, perennials, and even annuals can be
              mixed to provide bright and colorful plantings that will accent
              your walkway and bring a living element to your hardscape.
            </p>
            <img src={img010} alt="Feature" />
            <p>
              Just be sure to keep the beds adjacent to your walkways neatly
              groomed so that there is no overgrowth. A landscape designer can
              help choose plants that work best for your front yard’s sun
              exposure and make sure your paver walkway landscaping doesn’t
              encroach on your paths.
            </p>

            <h4 className="text-blue">14. Add Impact with Container Gardens</h4>
            <p>
              Some projects incorporate columns in the entryway, topped with
              container gardens. These pots are filled with bright annual blooms
              that can be seasonally updated for a fresh look. This is an easy
              addition to your paver walkway that has a big impact.
            </p>
            <img src={img011} alt="Feature" />

            <h4 className="text-blue">
              Using a Pro to Install Your Front Paver Walkway
            </h4>
            <p>
              Before falling in love with a specific idea, connect with a
              professional who will know what works best for your home
              specifically in terms of design and layout. Bringing your ideas to
              the initial design consultation is incredibly helpful in working
              through the process. At Pacific Pavingstone, our in house
              designers and installation teams have built thousands of front
              walkway projects. We not only have a wealth of ideas, but also the
              know - how to create the front paver walkway that is best for you.
              Working with your ideas, we can add serious curb appeal to your
              Southern California home.
            </p>
            <p>
              Contact us for more information to get a free front{" "}
              <Link to="/contact-us">paver walkway estimate</Link> or you may
              also call us at (818 ) 392 - 5085.
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(PaverWalkway);
